var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckmark = function SvgIconCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    fill: "none",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.898 5.673a.88.88 0 0 0-1.247 0l-.085.085a.88.88 0 0 0 0 1.248l2.708 2.708v.001l1.332 1.333L5.94 9.715l7.373-7.374a.88.88 0 0 0 0-1.248l-.085-.085a.88.88 0 0 0-1.248 0l-6.75 6.75a.88.88 0 0 1-1.247 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCheckmark;